import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  CardContainer,
  CardBody,
  CardItem,
} from "../../ui/3d-card";

export const ProjectCard = ({ imgUrl, link, alt, title }) => {
  return (
    <Col xs={12} sm={6} lg={3} className="d-flex justify-content-center">
      <div
        className="product-card-wrapper"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-easing="ease-in-sine"
        data-aos-duration="600"
      >
        <Link to={link} className="proj-link" aria-label={title || alt}>
          {/* 3D CARD */}
          <CardContainer containerClassName="product-card-container">
            <CardBody className="product-card-body">
              <CardItem translateZ={45} className="product-card-item">
                <img src={imgUrl} alt={alt || title} className="product-image" />
              </CardItem>
            </CardBody>
          </CardContainer>
        </Link>
      </div>
    </Col>
  );
};
